import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Bar from './pages/Bar';
import Chat from './pages/Chat';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Profile from './pages/Profile';
import { AuthProvider } from './components/auth/AuthProvider';

function App() {
  return (
    <AuthProvider>
      {/* 🔧 修復：移除全局 Navbar，徹底解決所有頁面頂部 UI 堆疊重疊的問題。
          現在每個頁面都會有自己專屬、完美契合場景的 Header。 */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/bar" element={<Bar />} />
        <Route path="/chat/:charId" element={<Chat />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;